var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCodes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.375 5.25H6.125C5.64175 5.25 5.25 5.64175 5.25 6.125V11.375C5.25 11.8582 5.64175 12.25 6.125 12.25H11.375C11.8582 12.25 12.25 11.8582 12.25 11.375V6.125C12.25 5.64175 11.8582 5.25 11.375 5.25Z",
    stroke: "#00ADEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 15.75H6.125C5.64175 15.75 5.25 16.1418 5.25 16.625V21.875C5.25 22.3582 5.64175 22.75 6.125 22.75H11.375C11.8582 22.75 12.25 22.3582 12.25 21.875V16.625C12.25 16.1418 11.8582 15.75 11.375 15.75Z",
    stroke: "#00ADEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875 5.25H16.625C16.1418 5.25 15.75 5.64175 15.75 6.125V11.375C15.75 11.8582 16.1418 12.25 16.625 12.25H21.875C22.3582 12.25 22.75 11.8582 22.75 11.375V6.125C22.75 5.64175 22.3582 5.25 21.875 5.25Z",
    stroke: "#00ADEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.75V19.25",
    stroke: "#00ADEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 22.75H19.25V15.75",
    stroke: "#00ADEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 17.5H22.75",
    stroke: "#00ADEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 21V22.75",
    stroke: "#00ADEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodes);
export default __webpack_public_path__ + "static/media/QR-Codes.cc191ec98572f43e45e53605f31d8d32.svg";
export { ForwardRef as ReactComponent };